import React from 'react';
import { Table } from 'react-bootstrap';

/**
 * Formatea cadenas de fecha (YYYY-MM-DD) sin sufrir desplazamientos de zona horaria UTC en el navegador.
 */
const formatFecha = (dateStr) => {
  if (!dateStr) return null;
  const match = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const [, year, month, day] = match;
    return `${day}/${month}/${year}`;
  }
  return dateStr;
};

/**
 * Evalúa el vencimiento documental de forma exacta respecto del fin del día local.
 */
const checkVencimiento = (vtoStr) => {
  if (!vtoStr) return { hasVto: false, isVencida: false, texto: 'No posee fecha de vencimiento' };
  const match = String(vtoStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return { hasVto: false, isVencida: false, texto: vtoStr };

  const [, year, month, day] = match;
  const vtoDate = new Date(Number(year), Number(month) - 1, Number(day), 23, 59, 59);
  const now = new Date();
  const isVencida = vtoDate < now;
  const formatted = `${day}/${month}/${year}`;

  return {
    hasVto: true,
    isVencida,
    formatted,
    texto: `${formatted} – ${isVencida ? 'VENCIDA' : 'VIGENTE'}`,
  };
};

export default function DatosHabilitacionTable({ data }) {
  const vencimiento = checkVencimiento(data?.fechaHabilitacionVto);

  const vencimientoEstilo = vencimiento.hasVto
    ? {
        backgroundColor: vencimiento.isVencida ? '#facccc' : '#dbf5e0',
        color: vencimiento.isVencida ? '#5a1118' : '#0a4718',
        fontWeight: 'bold',
        border: `2px solid ${vencimiento.isVencida ? '#f8c0c4' : '#b8e6c1'}`,
        textAlign: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
      }
    : { textAlign: 'center', verticalAlign: 'middle' };

  const isCedula = data?.tipoDocumento === 'CEDULA_EMBARCO';

  return (
    <div className="my-4" style={{ maxWidth: '95%', margin: '0 auto' }}>
      <h2
        className="mb-3"
        style={{
          textAlign: 'center',
          color: '#3C8DBC',
          fontWeight: 'bold',
        }}
      >
        {isCedula ? 'Datos de Cédula de Embarco' : 'Datos de Habilitación'}
      </h2>

      <Table
        striped
        bordered
        hover
        responsive
        size="sm"
        className="shadow-sm text-center align-middle"
        style={{ borderRadius: '8px', overflow: 'hidden' }}
      >
        <thead style={{ backgroundColor: '#3C8DBC', color: '#fff' }}>
          <tr>
            <th style={{ width: '30%' }}>{isCedula ? 'Cédula' : 'Habilitación'}</th>
            <th style={{ width: '20%' }}>{isCedula ? 'Nro Cédula' : 'Nro Habilitación'}</th>
            <th style={{ width: '20%' }}>{isCedula ? 'Fecha Alta' : 'Fecha Título'}</th>
            <th style={{ width: '30%' }}>Fecha Vencimiento</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="fw-semibold">{data.habilitacion}</td>
            <td className="fw-semibold">{data.nroHabilitacion}</td>

            <td style={{ whiteSpace: 'nowrap' }}>
              {formatFecha(data.fechaTituloOtorgado) || 'No disponible'}
            </td>

            <td style={vencimientoEstilo}>
              {vencimiento.hasVto ? (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                  <span>{vencimiento.isVencida ? '⛔️' : '✅'}</span>
                  <span>{vencimiento.texto}</span>
                </span>
              ) : (
                'No posee fecha de vencimiento'
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
